export default {
  name: "KilaKilaAdminMenu"
};